/* Three Moment Stories — mobile uses native horizontal swipe plus predictable arrows and low-frequency autoplay. */
(() => {
  const initStories = (root) => {
    if (!root || root.dataset.jcSceneReady === 'true') return;
    const track = root.querySelector('[data-jc-scene-track]');
    const stories = track ? [...track.querySelectorAll('.jc-scene-story')] : [];
    const dots = [...root.querySelectorAll('[data-jc-scene-dot]')];
    const previous = root.querySelector('[data-jc-scene-prev]');
    const next = root.querySelector('[data-jc-scene-next]');
    if (!track || stories.length < 2) return;
    root.dataset.jcSceneReady = 'true';
    let index = 0;
    let autoPlay = null;
    const isMobile = () => window.matchMedia('(max-width: 989px)').matches;
      const setIndex = (nextIndex, shouldScroll = true) => {
        index = (nextIndex + stories.length) % stories.length;
        stories.forEach((story, storyIndex) => story.classList.toggle('is-jc-scene-target', storyIndex === index));
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        if (shouldScroll && isMobile()) track.scrollTo({ left: stories[index].offsetLeft - (track.clientWidth - stories[index].clientWidth) / 2, behavior: 'smooth' });
      };
    const stopAutoPlay = () => { if (autoPlay) window.clearInterval(autoPlay); autoPlay = null; };
    const startAutoPlay = () => {
      stopAutoPlay();
      if (!isMobile() || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      autoPlay = window.setInterval(() => setIndex(index + 1), 5600);
    };
    previous?.addEventListener('click', () => { setIndex(index - 1); startAutoPlay(); });
    next?.addEventListener('click', () => { setIndex(index + 1); startAutoPlay(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { setIndex(Number(dot.dataset.jcSceneDot || 0)); startAutoPlay(); }));
    track.addEventListener('touchstart', stopAutoPlay, { passive:true });
    track.addEventListener('touchend', startAutoPlay, { passive:true });
    let scrollFrame = null;
    track.addEventListener('scroll', () => {
      if (!isMobile()) return;
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        const trackCenter = track.getBoundingClientRect().left + track.clientWidth / 2;
        const closest = stories.reduce((bestIndex, story, storyIndex) => Math.abs((story.getBoundingClientRect().left + story.clientWidth / 2) - trackCenter) < Math.abs((stories[bestIndex].getBoundingClientRect().left + stories[bestIndex].clientWidth / 2) - trackCenter) ? storyIndex : bestIndex, 0);
        setIndex(closest, false);
      });
    }, { passive:true });
    const requestedMoment = new URLSearchParams(window.location.search).get('moment');
    const requestedIndex = stories.findIndex((story) => story.dataset.jcSceneKey === requestedMoment);
    if (requestedIndex >= 0) {
      window.requestAnimationFrame(() => setIndex(requestedIndex));
    } else {
      setIndex(0, false);
    }

    window.addEventListener('resize', startAutoPlay, { passive:true });
    startAutoPlay();
  };
  const initAll = (scope = document) => scope.querySelectorAll?.('[data-jc-scene-picks]').forEach(initStories);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initAll()) : initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
